import React from 'react';
import classes from '../../components/Contact/Contact.module.scss';

export default () => (
  <article style={{ backgroundColor: '#fff', height: '100%' }}>
    <section className={classes.detailsContainer}>
      <div className="container">
        <div className={classes.contactDetails}>
          <div className={classes.singleDetail}>
            <span className={classes.label}>Mail:</span>
            <a href="mailto:kingedward@encoregroup.co.uk">kingedward@encoregroup.co.uk</a>
          </div>

          <div className={classes.singleDetail}>
            <span className={classes.label}>Address:</span>
            <div>
              King Edward VII Estate <br />
              Kings Drive <br />
              Midhurst <br />
              GU29 0EX <br />
            </div>
          </div>
          <div className={classes.singleDetail}>
            <span className={classes.label}>Telephone number:</span>
            01730 814217
          </div>
        </div>
      </div>
    </section>
  </article>
);
